<h2 mat-dialog-title>{{ 'PAYMENT_METHOD_SELECTOR.PAYMENT_METHODS' | translate }}</h2>
<mat-dialog-content>
  <mat-radio-group [formControl]="paymentMethod" required="true" class="radio-group">
    <ng-container *ngIf="!hideExistingMethods">
      <ng-container *ngIf="paymentMethods$ | async as paymentMethods; else loadingSpinner">
        <ng-container *ngIf="!(paymentMethods?.size > 0)">
          <span class="no-cards">{{ 'PAYMENT_METHOD_SELECTOR.NO_PAYMENT_METHODS' | translate }}</span>
          <mat-divider></mat-divider>
        </ng-container>

        <ng-container *ngFor="let type of paymentMethods | keys; let firstKey = first">
          <p class="section-header" [class.remove-top-margin]="firstKey">{{ type | paymentTypeToTitle }}</p>
          <ng-container *ngFor="let paymentMethod of paymentMethods.get(type); let lastPaymentMethod = last">
            <span class="payment-method-row" [class.border-bottom]="!lastPaymentMethod">
              <mat-radio-button
                [value]="paymentMethod?.details?.id"
                (click)="selectMethod(paymentMethod?.details?.id)"
                [checked]="defaultPaymentMethod === paymentMethod?.details?.id"
              >
                <div class="payment-option">
                  <span class="payment-option-display">
                    <smb-invoicing-payment-method-display
                      [paymentMethod]="paymentMethod"
                    ></smb-invoicing-payment-method-display>
                    <span class="payment-method-badge">
                      @if (paymentMethod?.expired) {
                        <glxy-badge [color]="'red'">
                          {{ 'PAYMENT_METHOD_SELECTOR.EXPIRED' | translate }}
                        </glxy-badge>
                      } @else if (paymentMethod?.default) {
                        <glxy-badge [color]="'blue'">
                          {{ 'PAYMENT_METHOD_SELECTOR.DEFAULT' | translate }}
                        </glxy-badge>
                      }
                    </span>
                  </span>

                  <ng-container *ngIf="selectedMethod$$ | async as selectedMethod">
                    <button
                      *ngIf="paymentMethod?.details?.id !== selectedMethod || canRemoveSelectedMethod"
                      mat-icon-button
                      type="button"
                      (click)="removeMethod(paymentMethod, $event)"
                    >
                      <mat-icon class="remove-button">delete</mat-icon>
                    </button>
                  </ng-container>
                </div>
              </mat-radio-button>
            </span>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <p class="section-header">{{ 'PAYMENT_METHOD_SELECTOR.NEW_PAYMENT_METHOD' | translate }}</p>
    <mat-radio-button [value]="null">
      <mat-icon class="add-card-icon"> add_card </mat-icon>
      <span>{{ 'PAYMENT_METHOD_SELECTOR.ADD_CARD' | translate }}</span>
    </mat-radio-button>
    <div class="card-form" [ngClass]="{ hidden: paymentMethod.value !== null }">
      <div id="card-element" #cardElement>
        <!-- A Stripe Element will be inserted here. -->
      </div>
      <div id="card-errors" role="alert">&nbsp;{{ error }}</div>
    </div>
  </mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="primary">{{ 'PAYMENT_METHOD_SELECTOR.CANCEL' | translate }}</button>
  <button type="submit" mat-raised-button color="primary" [disabled]="isAddingMethod$$ | async" (click)="save()">
    <div class="loading-button">
      <ng-container *ngIf="(isAddingMethod$$ | async) === false; else loadingSpinner">
        <span>
          {{ submitDialogText }}
        </span>
      </ng-container>
    </div>
  </button>
</mat-dialog-actions>

<ng-template #loadingSpinner>
  <mat-progress-spinner [color]="'accent'" [diameter]="24" mode="indeterminate"></mat-progress-spinner>
</ng-template>
